import { getRuntimeBase } from '#/utils/runtimeBase';

/**
 * Resolves a path (e.g. from landing-page.json) so it works when the app
 * is served under a base path (e.g. /gov-benefit/).
 *
 * Call this at render time rather than module scope — it reads
 * `window.location` through `getRuntimeBase()`.
 */
export function assetUrl(path: string, contentBase?: string): string;
export function assetUrl(
  path: string | undefined,
  contentBase?: string
): string | undefined;
export function assetUrl(
  path: string | undefined,
  contentBase?: string
): string | undefined {
  if (!path) return path;
  if (path.startsWith('http')) return path;

  const appBase = getRuntimeBase();
  const clean = path.startsWith('/') ? path.slice(1) : path;

  // Absolute paths in content (e.g. "/hero-images/foo.jpg") should resolve from the app base,
  // not from a page-scoped contentBase like "/02/".
  const base = path.startsWith('/') ? appBase : (contentBase ?? appBase);
  return `${base}${clean}`;
}

/** Resolves a file in `public/icons/`. */
export function iconUrl(fileName: string): string {
  return assetUrl(`/icons/${fileName}`);
}
